import request from '../utils/request'
const Qs = require('qs');
export function getdataInfo() {
    return request({
        url:'kindergarten-api/asset/m/lovedonation',
        method:'get',
    })
}

export function getdataInfoDetail(id) {
    return request({
        url:'kindergarten-api/asset/m/lovedonation?id='+id,
        method:'get',
    })
}

export function getdataInfoUpdate(data) {
    return request({
        url:'kindergarten-api/asset/m/lovedonation/update',
        method:'post',
        data
    })
}
export function getdataInfoUpdatePay() {
    return request({
        url:'kindergarten-api/asset/m/lovedonation/pay',
        method:'post',
    })
}
export function sendMessage(mobile) {
    return request({
        url:'kindergarten-api/asset/m/send?tel='+mobile,
        method:'get',
    })
}
/*数据列表*/
export function oneList(params) {
    return request({
        url:'kindergarten-api/asset/m/proStudents',
        method:'get',
        params
    })
}
/*孩子的个人信息*/
export function stuInfo(params) {
    return request({
        url:'kindergarten-api/asset/m/stuInfo',
        method:'get',
        params
    })
}
/*支付接口*/
export function PayDonation(data) {
    return request({
        url:'kindergarten-api/asset/m/donationPay',
        headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
         },
        method:'post',
        data:Qs.stringify(data)
    })
}
/*获取捐赠人登录信息*/
export function proUsersave(data) {
    return request({
        url:'kindergarten-api/asset/m/proUsersave',
        // headers: {
        //     'Content-Type': 'application/x-www-form-urlencoded'
        // },
        method:'put',
       data
    })
}
export function login(data) {
    return request({
        url:'kindergarten-api/asset/m/login',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method:'post',
        data:Qs.stringify(data)
    })
}
// 爱心榜
export function loveBoard() {
    return request({
        url:'kindergarten-api/asset/m/loveBoard',
        method:'get',

    })
}
export function loveBanner() {
    return request({
        url:'kindergarten-api/asset/m/loveBanner',
        method:'get',

    })
}

/*项目报告
* */

export function proInfoReport(params) {
    return request({
        url:'kindergarten-api/asset/m/proInfoReport',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method:'get',
        params
    })
}
/*捐赠记录*/
export function proInfo(params) {
    return request({
        url:'kindergarten-api/asset/m/proInfo',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method:'get',
        params
    })
}



/*捐赠记录*/
export function proOrders(params) {
    return request({
        url:'kindergarten-api/asset/m/proOrders',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method:'get',
        params
    })
}

/*捐赠排行*/
export function proUserInfo(params) {
    return request({
        url:'kindergarten-api/asset/m/proUserInfo',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method:'get',
        params
    })
}
/*爱心反馈*/
export function loveResp(params) {
    return request({
        url:'kindergarten-api/asset/m/loveResp',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method:'get',
        params
    })
}
/*荣誉证书*/
export function loveCert(params) {
    return request({
        url:'kindergarten-api/asset/m/loveCert',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method:'get',
        params
    })
}

/*捐赠动态*/
export function lastProOrders(params) {
    return request({
        url:'kindergarten-api/asset/m/lastProOrders',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method:'get',
        params
    })
}
/*项目列表*/

export function proLst(params) {
    return request({
        url:'kindergarten-api/asset/m/proLst',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method:'get',
        params
    })
}

export function genLoveCert(params) {
    return request({
        url:'kindergarten-api/asset/m/genLoveCert',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method:'get',
        params
    })
}
/*组织排行榜*/
export function getLoveOrgan(params) {
    return request({
        url:'kindergarten-api/asset/m/loveBoardByOrg',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method:'get',
        params
    })
}
/*个人排行榜*/
export function getLovePerson(params) {
    return request({
        url:'kindergarten-api/asset/m/loveBoardByPu',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method:'get',
        params
    })
}
/*组织结构*/
export function getLoveorglist(params) {
    return request({
        url:'kindergarten-api/asset/m/orglist',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method:'get',
        params
    })
}
